import { combineReducers } from 'redux';
import mainTrackGroup from './MainTrack';
import chooseListManager from './chooseListManager';
import track from './TrackManager';

const reducer = combineReducers({
    Track: track,
    MainTrack: mainTrackGroup,
    ChooseListManager: chooseListManager
});

export default reducer;